import React, { useContext, useEffect } from "react";
import {
  IonContent,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillEnter,
} from "@ionic/react";
import { AuthenticationContext } from "../../providers/AuthenticationProvider/AuthenticationProvider";
import Spinner from "../../components/Spinner/Spinner";
import NoData from "../../components/NoData/NoData";
import useAPI from "../../hooks/basic/useAPI";
import SavedMatchCard from "../../components/SavedMatchCard/SavedMatchCard";
import { Link } from "react-router-dom";
import NewMatchModal from "../../components/NewMatchModal/NewMatchModal";
import CardListHeader from "../../components/CardListHeader/CardListHeader";
import { ClubsContext } from "../../providers/ClubsProvider/ClubsProvider";

const today = new Date();
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 2);

const MatchListPage = () => {
  const { coaches } = useContext(ClubsContext);
  const { appUserId, isCoach } = useContext(AuthenticationContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [matchList, setMatchList] = React.useState([]);
  const [athletes, setAthletes] = React.useState([]);
  const [openNewMatchModal, setOpenNewMatchModal] = React.useState(false);

  const { callAPI } = useAPI();

  useEffect(() => {
    if (!appUserId) {
      return;
    }
    if (isCoach) {
      populateAthletesByCoach();
    } else {
      populateAthletes();
    }
    refreshData();
  }, [appUserId]);

  const coachesIds = coaches.map((coach) => coach.id);

  const populateAthletes = async () => {
    const allAthletes = await callAPI({
      url: "/athletes-by-coaches",
      params: {
        coachesIds: coachesIds.join(","),
      },
      preventCall: !appUserId,
    });
    // sort athletes by cognome then nome
    allAthletes.sort((a, b) => {
      const nameA = a.cognome.toLowerCase();
      const nameB = b.cognome.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    setAthletes(allAthletes);
  };

  const populateAthletesByCoach = async () => {
    const allAthletes = await callAPI({
      url: "/athletes-by-coach",
      params: {
        coachId: appUserId,
      },
      preventCall: !appUserId,
    });
    // sort athletes by cognome then nome
    allAthletes.sort((a, b) => {
      const nameA = a.cognome.toLowerCase();
      const nameB = b.cognome.toLowerCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    setAthletes(allAthletes);
  };

  const refreshData = async () => {
    setIsLoading(true);
    try {
      const response = await fetchMatchList();
      setIsLoading(false);
      if (response && response.length > 0) {
        setMatchList(response);
      } else {
        setMatchList([]);
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.error("Error fetching match list:", error);
    }
  };

  const fetchMatchList = async () => {
    return await callAPI({
      url: `/match-list`,
      params: {
        userId: appUserId,
      },
    });
  };

  useIonViewWillEnter(() => {
    if (appUserId) {
      refreshData();
    }
  });

  const handleRefresh = (e) => {
    refreshData();
    e.detail.complete();
  };

  return (
    <IonPage>
      <IonContent id="main-content">
        <CardListHeader onAddClick={() => setOpenNewMatchModal(true)} />
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        {/* <SubscriptionPaymentRemainder /> */}
        {isLoading && <Spinner />}
        {!isLoading && matchList.length === 0 && (
          <NoData
            messageTitle="Non hai eventi in programma"
            message="Consulta gli eventi disponibili o contatta il tuo allenatore"
          />
        )}
        {error && <p>Error: {error.message}</p>}
        <h1
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            color: "#062a40",
            letterSpacing: "0.0125em",
          }}
        >
          Partite
        </h1>
        {matchList.map((match) => (
          <SavedMatchCard key={match.id} data={match} />
        ))}
      </IonContent>
      {openNewMatchModal && (
        <NewMatchModal
          isOpen={openNewMatchModal}
          athletes={athletes}
          onDidDismiss={() => setOpenNewMatchModal(false)}
          creatorId={appUserId}
        />
      )}
    </IonPage>
  );
};

export default MatchListPage;
